var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChecklistGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 16,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00B0A0",
    d: "M7 .375c-.34 0-.639.111-.896.334-.247.2-.434.463-.563.791H.812v14.063h12.376V1.5H8.459a1.875 1.875 0 0 0-.563-.791A1.33 1.33 0 0 0 7 .375ZM7 1.5a.5.5 0 0 1 .387.176.5.5 0 0 1 .176.387v.562H9.25V3.75h-4.5V2.625h1.688v-.563c0-.152.052-.28.158-.386A.556.556 0 0 1 7 1.5ZM1.937 2.625h1.688v2.25h6.75v-2.25h1.688v11.813H1.937V2.624Zm8.034 4.096-3.534 3.533-1.845-1.846-.809.809 2.25 2.25.404.386.405-.386 3.937-3.938-.808-.808Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecklistGreen);
export default __webpack_public_path__ + "static/media/checklistGreen.4598ecf77aa35ab19758358a48bb4cef.svg";
export { ForwardRef as ReactComponent };